import { render, staticRenderFns } from "./SearchDetails.vue?vue&type=template&id=125b60ac&scoped=true&"
import script from "./SearchDetails.vue?vue&type=script&lang=js&"
export * from "./SearchDetails.vue?vue&type=script&lang=js&"
import style0 from "./SearchDetails.vue?vue&type=style&index=0&id=125b60ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b60ac",
  null
  
)

export default component.exports